// extracted by mini-css-extract-plugin
export var columnList = "_ez-0";